export type TooltipPlacement = "right" | "left";

export type TooltipAnchorRect = {
	top: number;
	bottom: number;
	left: number;
	right: number;
};

export type TooltipSize = { width: number; height: number };

export type TooltipPosition = {
	top: number;
	left: number;
	placement: TooltipPlacement;
};

const VIEWPORT_PADDING = 8;

/** Places the tooltip beside its anchor, flipping sides when the preferred one does not fit. */
export const computeTooltipPosition = (
	anchor: TooltipAnchorRect,
	tooltip: TooltipSize,
	viewport: TooltipSize,
	gap = 8,
): TooltipPosition => {
	const fitsRight = anchor.right + gap + tooltip.width <= viewport.width - VIEWPORT_PADDING;
	const placement: TooltipPlacement = fitsRight ? "right" : "left";
	const left = fitsRight ? anchor.right + gap : anchor.left - gap - tooltip.width;

	const centeredTop = anchor.top + (anchor.bottom - anchor.top - tooltip.height) / 2;
	const maxTop = viewport.height - tooltip.height - VIEWPORT_PADDING;
	const top = Math.round(Math.min(Math.max(centeredTop, VIEWPORT_PADDING), maxTop));

	// Clamp left coordinate to viewport bounds, keeping placement unchanged
	const minLeft = VIEWPORT_PADDING;
	const maxLeft = viewport.width - tooltip.width - VIEWPORT_PADDING;
	const clampedLeft = Math.round(Math.min(Math.max(left, minLeft), maxLeft));

	return { top, left: clampedLeft, placement };
};
